export const GET_SOURCES_START = 'GET_SOURCES_START';
export const GET_SOURCES_COMPLETE = 'GET_SOURCES_COMPLETE';
export const GET_SOURCES_ERROR = 'GET_SOURCES_ERROR';
export const GET_REPOS_START = 'GET_REPOS_START';
export const GET_REPOS_COMPLETE = 'GET_REPOS_COMPLETE';
export const GET_REPOS_ERROR = 'GET_REPOS_ERROR';
export const GET_BRANCHES_START = 'GET_BRANCHES_START';
export const GET_BRANCHES_COMPLETE = 'GET_BRANCHES_COMPLETE';
export const GET_BRANCHES_ERROR = 'GET_BRANCHES_ERROR';
